<template>
  <div>
    <div class="home">
      <div class="content">
        <img class="mobile_logo" src="/mobile/static/img/restricted_prompt/mobile_logo.png" alt="">
        <div class="mobile_content">
          <p class="title primary_color"><img class="mark_icon" src="/mobile/static/img/restricted_prompt/mark_icon.png" alt="">
            {{ i18n[locale].title }}
          </p>
          <p v-for="(item, index) in i18n[locale].content.split(/\r?\n/)" :key="index">
            {{ item }}
          </p>
        </div>
      </div>
      <prompt-footer></prompt-footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import promptFooter from '@/components/layout/PromptFooter'

export default {
  data () {
    return {
      locale: 'en',
      i18n: {
        tc: {
          title: '網站存取受地理限制',
          content: `我們遺憾地通知您，該遊戲的網路版目前在您所在的地區無法訪問，可能是由於法律限制、許可協議或其他因素。非常感謝您的體諒。
 如有任何疑問或協助，請聯絡我們的支援團隊：info@kkpoker.net。
 請繼續關注進一步更新！` },
        en: {
          title: 'Website Access Geo-Restricted',
          content: `We regret to inform you that the web version of this game is presently inaccessible in your region, possibly due to legal constraints, licensing agreements, or other factors. Your understanding is greatly appreciated.

 For any inquiries or assistance, please contact our support team at info@kkpoker.net.

 Stay tuned for further updates!`
        },
        ru: {
          title: 'Сайт недоступен в вашем регионе',
          content: `К сожалению, в настоящее время веб-версия игры недоступна в вашем регионе в силу правовых ограничений, условий лицензионных соглашений или иных факторов. Благодарим за понимание.

 Если у вас возникли вопросы или вам нужна помощь, обратитесь в нашу службу поддержки по адресу info@kkpoker.net.

 Следите за новостями!`
        },
        jp: {
          title: '地域制限によりWebサイトにアクセスできません',
          content: `本ゲームのWeb版は、法規制やライセンス契約等の理由により、現在お住まいの地域からはご利用いただけません。何卒ご理解のほどよろしくお願いいたします。

 今後のアップデート情報につきましては随時更新してまいります。

 お問い合わせやサポートをご希望の場合は弊社サポートチーム info@kkpoker.net までご連絡ください。`
        },
        es: {
          title: 'Acceso al sitio web restringido geográficamente',
          content: `Lamentamos informarte que la versión web de este juego no está disponible actualmente en tu región, posiblemente por razones legales, acuerdos de licencia u otros factores. Muchas gracias por tu comprensión.

 Para cualquier consulta o ayuda, contacta a nuestro equipo de soporte a info@kkpoker.net.

 ¡Mantente alerta para más novedades!`
        },
        th: {
          title: 'ปิดกั้นการเข้าถึงเว็บไซต์ตามตำแหน่งภูมิศาสตร์',
          content: `เราเสียใจเป็นอย่างยิ่งที่จะต้องแจ้งว่าภูมิภาคของคุณไม่สามารถเข้าถึงเวอร์ชันเว็บของเกมนี้ได้ โดยอาจเกิดจากข้อจำกัดทางกฎหมาย สัญญาอนุญาตให้ใช้สิทธิ หรือปัจจัยอื่นๆ ขอบคุณเป็นอย่างยิ่งที่เข้าใจ

 สำหรับข้อสงสัยหรือความช่วยเหลือใดๆ โปรดติดต่อฝ่ายบริการลูกค้าของเราที่ info@kkpoker.net

 โปรดติดตามอัปเดตต่อไป!`
        },
        hi: {
          title: 'वेबसाइट का एक्सेस आपके क्षेत्र में प्रतिबंधित है',
          content: `हमें आपको यह बताते हुए खेद हो रहा है कि संभवतः कानूनी बाधाओं, लाइसेंसिंग समझौतों या अन्य कारकों की वजह से इस गेम का वेब संस्करण वर्तमान में आपके क्षेत्र में एक्सेस योग्य नहीं है। स्थिति को समझने के लिए हम आपकी बहुत सराहना करते हैं।

 किसी भी पूछताछ या सहायता के लिए, कृपया info@kkpoker.net पर हमारी सहायता टीम से संपर्क करें।

 आगे के अपडेट के लिए बने रहें!`
        },
        pt: {
          title: 'Acesso ao site restrito por região',
          content: `Lamentamos informar que não é possível acessar a versão web do jogo em sua região, possivelmente por causa de restrições legais, contratos de licença ou outros fatores. Agradecemos a compreensão.

 Para dúvidas ou assistência, entre em contato com nossa equipe de atendimento em info@kkpoker.net.

 Fique ligado para mais atualizações!`
        },
        kr: {
          title: '웹사이트 접근 지역 제한됨',
          content: `죄송합니다. 법적 제약, 라이선스 계약, 기타 요인으로 인해 현재 귀하의 지역에서 웹 게임 버전을 이용할 수 없습니다. 양해해 주셔서 정말 감사합니다.

 문의나 도움이 필요한 경우 지원팀에 문의해 주시기 바랍니다. (info@kkpoker.net)

 향후 업데이트를 기대해주세요!`
        },
        mn: {
          title: 'Вебсайтын хандалтыг газар зүйн хувьд хязгаарласан',
          content: `Энэ тоглоомын вэб хувилбар одоогоор танай бүс нутагт хуулийн шаардлага, лицензийн гэрээ ба бусад хүчин зүйлийн улмаас хандах боломжгүй байгааг танд дуулгахад харамсалтай байна. Ойлгож байгаад маш их талархлаа.

 Лавлагаа, тусламж авах бол info@kkpoker.net хаягаар манай дэмжлэгийн багтай холбоо барина уу.

 Цаашдын шинэчлэлт авах бол холбоотой байгаарай!`
        },
        pl: {
          title: 'Dostęp do tej strony jest ograniczony geograficznie',
          content: `Niestety wersja tej gry w przeglądarce jest obecnie niedostępna w Twoim regionie z powodu ograniczeń prawnych, umów licencyjnych lub innych czynników. Dziękujemy za zrozumienie.

 W razie pytań prosimy o kontakt z naszym zespołem pomocy technicznej pod adresem info@kkpoker.net.

 Wypatruj aktualizacji na ten temat!`
        },
        fr: {
          title: 'Site sous restriction géographique',
          content: `Nous avons le regret de vous informer que la version Web de ce jeu est actuellement inaccessible depuis votre région, potentiellement en raison de contraintes légales, de contrats de licence ou d'autres facteurs. Nous vous remercions de votre compréhension.

 Pour toute question ou demande d'aide, veuillez contacter notre équipe d'assistance à info@kkpoker.net.

 Ne manquez pas nos futures mises à jour !`
        }
      }
    }
  },
  components: {
    promptFooter
  },
  created () {
    const urlParams = new URLSearchParams(window.location.search)
    const lang = urlParams.get('lang') || 'en'
    if (this.i18n[lang]) {
      this.locale = lang
    }
  }
}
</script>

<style lang="scss" scoped>
  .home {
    position: relative;

    background-image: url("/mobile/static/img/restricted_prompt/mobile_bg.jpg");
    background-repeat: no-repeat;
    // background-size: cover;
    background-position: top center;
    background-size: 100% auto;
    background-color: #050505;

    width: 100%;
    // height: 100%;
    height: 1500px;
    font-size: 24px;
    color: #e7e7e7;
    .content {
      padding: 140px 60px 40px 60px;
      text-align: center;
      .mobile_logo {
        display: inline-block;
        width: 420px;
        text-align: center;
        margin-bottom: 80px;
      }
      .mobile_content {
        width: 100%;
        text-align: left;
        .title {
          font-weight: bold;
          font-size: 36px;
          line-height: 40px;
          vertical-align: middle;
          color: #219655;
          margin-bottom: 30px;
          .mark_icon {
            vertical-align: middle;
            height: 36px;
            display: inline-block;
            margin-bottom: 6px;
          }
        }
        p {
          font-size: 26px;
          line-height: 36px;
          margin-bottom: 20px;
          font-weight: 100;
          padding-left: 16px;
          a {
            font-weight: 400;
            color: #e7e7e7;
            font-size: 26px;
          }
        }
      }
    }
  }
</style>
